import { CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_ERROR } from './../const';

function action(errorCallback) {
  return { type: CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_ERROR, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyMailUnsubscribeError.js